module.exports = __webpack_public_path__ + "img/statistics_a.fd141675.png";